import {observer} from "mobx-react";
import React, {useEffect} from "react";
import {FormEntryNew} from "controls/react/form/formEntryNew";
import {SketchColorPicker} from "controls/react/colorPicker/sketchColorPicker";
import {sharedLocalization} from "controls/designer/features/widgets/localization";
import {gradient} from "tools/colorHelpers";
import {makeAutoObservable} from "mobx";

const i18n = require('core/localization/localization').translator({
	'From': {no: 'Fra'},
	'To': {no: 'Til'}
}, sharedLocalization);

export const DEFAULT_COLOR_PALETTE = {start: '#0B1F4B', end: '#E9F2FF'};

export class ColorPalette {
	start: string
	end: string;

	get startColor() {
		return {hex: this.start};
	}
	set startColor(value: {hex: string}) {
		this.start = value.hex;
	}
	set endColor(value: {hex: string}) {
		this.end = value.hex;
	}
	get endColor() {
		return {hex: this.end};
	}

	private values: string[] = [];
	constructor(data?: Partial<ColorPalette>) {
		Object.assign(this, data);
		makeAutoObservable(this, {build: false});
	}

	*build(count: number) {
		this.values = gradient(this.start, this.end, count);

		while(true)
			for(const color of this.values)
				yield color;
	}
}

export type ColorPaletteEditorProps = {
	value?: ColorPalette,
	onChange?: (value: ColorPalette) => void,
}

export const ColorPaletteEditor = observer((props: ColorPaletteEditorProps) => {
	useEffect(() => {
		if (!props.value) {
			props.onChange?.(new ColorPalette());
		}
	}, [props.value]);

	return <>
		<FormEntryNew label={i18n('From')} model={props.value} modelField={'startColor'}>
			<SketchColorPicker />
		</FormEntryNew>
		<FormEntryNew label={i18n('To')} model={props.value} modelField={'endColor'}>
			<SketchColorPicker />
		</FormEntryNew>
	</>
})
